export const ACTIVATE_MODAL = 'ACTIVATE_MODAL';
export const DISMISS_MODAL = 'DISMISS_MODAL';

export function activateModal(modal) {
  return {
    type: ACTIVATE_MODAL,
    modal
  };
}

export function dismissModal() {
  return {
    type: DISMISS_MODAL
  };
}



// WEBPACK FOOTER //
// ./containers/modal-manager/modal-manager-actions.js